import * as io from 'io-ts';
import { MerchantConfig } from './MerchantConfig';
import { Capabilities, MerchantProgramValues } from './MerchantProgramValues';
import { MerchantDetails } from './MerchantDetails';
import { MerchantPaymentProduct } from './PaymentProduct';

const Currency = io.union([io.literal('USD'), io.literal('CAD')]);
export type Currency = io.TypeOf<typeof Currency>;

export enum CheckoutChannels {
  InStorePlatform = 'Instore - Platform',
  EcommEnhancedPreQual = 'Ecomm - Enhanced PreQual',
  InhomeVirtualCard = 'Inhome - Virtual Card',
  InStoreUnifiedPrequalVirtualCard = 'InStore - Unified Prequal - Virtual Card',
  Inhome = 'Inhome',
  Ecomm = 'Ecomm',
  InstorePOS = 'Instore - POS',
  InstoreVirtualCard = 'Instore - Virtual Card',
  EcommerceVirtualCard = 'Ecommerce - Virtual Card',
}

export const CheckoutChannel = io.union([
  io.literal(CheckoutChannels.InStorePlatform),
  io.literal(CheckoutChannels.InStoreUnifiedPrequalVirtualCard),
  io.literal(CheckoutChannels.InhomeVirtualCard),
  io.literal(CheckoutChannels.Inhome),
  io.literal(CheckoutChannels.InstoreVirtualCard),
  io.literal(CheckoutChannels.EcommerceVirtualCard),
  io.literal(CheckoutChannels.InstorePOS),
  io.literal(CheckoutChannels.Ecomm),
  io.literal(CheckoutChannels.EcommEnhancedPreQual),
]);

export type CheckoutChannel = io.TypeOf<typeof CheckoutChannel>;

export const Program = io.type({
  id: io.string,
  tenantID: io.string,
  name: io.string,
  currency: Currency,
  defaultLanguage: io.string,
  displayInterestRateBPS: io.number,
  policies: io.type({
    application: io.type({
      tof: io.type({
        disclosures: io.union([
          io.array(
            io.type({
              type: io.string,
              requiresChecksum: io.boolean,
            })
          ),
          io.undefined,
        ]),
      }),
    }),
  }),
  capabilities: Capabilities,
  checkoutChannel: CheckoutChannel,
});

export type Program = io.TypeOf<typeof Program>;

const ProgramListLookupID = io.type({
  id: io.string,
});

export const ProgramListResponse = io.type({
  programs: io.array(ProgramListLookupID),
});

export type ProgramListResponse = io.TypeOf<typeof ProgramListResponse>;

export const AggregatedMerchantProgramConfiguration = io.intersection([
  io.type({
    program: Program,
    merchantPaymentProducts: io.array(MerchantPaymentProduct),
    merchantProgramValues: MerchantProgramValues,
    merchantDetails: MerchantDetails,
  }),
  io.partial({
    merchantConfig: MerchantConfig,
  }),
]);

export type AggregatedMerchantProgramConfiguration = io.TypeOf<
  typeof AggregatedMerchantProgramConfiguration
>;
